module.exports = __webpack_public_path__ + "static/media/icon-star.f2447eb8.svg";